import { INFO_THEME_IMAGE_BEAMER } from '../components/infoblock'
import { ACTION_SIGNUP } from '../constants/actions'

export const CONTENT_INFOBLOCK_UNKONF_HEROIMAGE = {
  title: `Hallo Speaker!`,
  content:
    'Leider müssen wir die ursprünglich für den 20.03.2026 angekündigte SpeaKonf auf verschiedenen Gründen absagen. Wir werden einen alternativen Termin im zweiten Halbjahr einplanen.<br/><br/>Vorträge, Talks & MeetUps – was sind eure Erfahrungen? Auf der SpeaKonf tauschen wir unsere Erfahrungen aus – sei dabei!',
  theme: INFO_THEME_IMAGE_BEAMER,
  action: ACTION_SIGNUP,
  isHeroImage: true,
}
